module.exports = __webpack_public_path__ + "static/media/drinking.6a1014c1.svg";